import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaTrash, FaCalendarAlt } from 'react-icons/fa';
import toast from 'react-hot-toast';

const TYPE_COLORS = { holiday:'#10b981', exam:'#ef4444', sports:'#f59e0b', meeting:'#0d6efd', trip:'#8b5cf6', other:'#6b7280' };

export default function Events() {
  const [events,  setEvents]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState(false);
  const [form,    setForm]    = useState({ title:'', description:'', event_date:'', end_date:'', event_type:'other' });

  const load = () => adminApi.getEvents({ from: `${new Date().getFullYear()}-01-01`, to: `${new Date().getFullYear()}-12-31` })
    .then(r => setEvents(r.data.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try { await adminApi.addEvent(form); toast.success('Event added'); setModal(false); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  return (
    <div>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div><h2>School Events</h2><p>Calendar of events for {new Date().getFullYear()}</p></div>
        <button className="sms-btn sms-btn-primary" onClick={()=>{ setForm({title:'',description:'',event_date:'',end_date:'',event_type:'other'}); setModal(true); }}><FaPlus size={13}/> Add Event</button>
      </div>

      {loading ? <Spinner /> : (
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {events.map(e => (
            <div key={e.event_id} className="sms-card" style={{ display:'flex', alignItems:'center', gap:16, padding:'16px 20px', borderLeft:`4px solid ${TYPE_COLORS[e.event_type]||'#6b7280'}` }}>
              <div style={{ width:52, height:52, borderRadius:12, background:`${TYPE_COLORS[e.event_type]}22`, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                <div style={{ fontSize:'1.3rem', fontWeight:700, color:TYPE_COLORS[e.event_type], lineHeight:1 }}>{new Date(e.event_date).getDate()}</div>
                <div style={{ fontSize:'0.65rem', color:TYPE_COLORS[e.event_type], textTransform:'uppercase' }}>{new Date(e.event_date).toLocaleString('en',{month:'short'})}</div>
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:600 }}>{e.title}</div>
                {e.description && <div style={{ color:'#6b7280', fontSize:'0.85rem', marginTop:2 }}>{e.description}</div>}
                <div style={{ marginTop:4, display:'flex', gap:12, fontSize:'0.78rem', color:'#9ca3af' }}>
                  <span style={{ background:`${TYPE_COLORS[e.event_type]}22`, color:TYPE_COLORS[e.event_type], padding:'2px 8px', borderRadius:10, fontWeight:500, textTransform:'capitalize' }}>{e.event_type}</span>
                  {e.end_date && e.end_date !== e.event_date && <span>Until {e.end_date}</span>}
                  <span>By {e.created_by_name}</span>
                </div>
              </div>
              <button className="sms-btn sms-btn-danger sms-btn-sm" onClick={async()=>{ if(window.confirm('Delete?')){ await adminApi.deleteEvent(e.event_id); toast.success('Deleted'); load(); }}}><FaTrash size={12}/></button>
            </div>
          ))}
          {events.length===0 && <div className="sms-card" style={{textAlign:'center',color:'#9ca3af',padding:'60px 0'}}><FaCalendarAlt size={40} style={{marginBottom:12,opacity:0.3}}/><br/>No events scheduled</div>}
        </div>
      )}

      <Modal show={modal} onClose={()=>setModal(false)} title="Add Event">
        <form onSubmit={handleSave}>
          <div style={{marginBottom:14}}><label className="sms-label">Title <span style={{color:'#ef4444'}}>*</span></label><input className="sms-input" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} required /></div>
          <div style={{marginBottom:14}}><label className="sms-label">Description</label><textarea className="sms-input" rows={3} value={form.description} onChange={e=>setForm({...form,description:e.target.value})} style={{resize:'vertical'}} /></div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
            <div><label className="sms-label">Event Date <span style={{color:'#ef4444'}}>*</span></label><input className="sms-input" type="date" value={form.event_date} onChange={e=>setForm({...form,event_date:e.target.value})} required /></div>
            <div><label className="sms-label">End Date</label><input className="sms-input" type="date" value={form.end_date} onChange={e=>setForm({...form,end_date:e.target.value})} /></div>
          </div>
          <div style={{marginBottom:20}}><label className="sms-label">Event Type</label>
            <select className="sms-input" value={form.event_type} onChange={e=>setForm({...form,event_type:e.target.value})}>
              {Object.keys(TYPE_COLORS).map(t=><option key={t} value={t} style={{textTransform:'capitalize'}}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
            </select>
          </div>
          <div style={{display:'flex',gap:10}}>
            <button type="submit" className="sms-btn sms-btn-primary">Save</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={()=>setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
